/*
 *  主页面js
 */
import Vue from 'vue'
import App from './App.vue'
// >>>引入js
import $ from 'jquery'
import fontsize from './assets/js/fontSize'
// >>>引入弹窗插件
import wcPop from './assets/js/wcPop/wcPop'
import './assets/js/wcPop/skin/wcPop.css'
// >>>引入饿了么移动端vue组件库
import MintUI, { Loadmore } from 'mint-ui'
import 'mint-ui/lib/style.css'
Vue.component(Loadmore.name, Loadmore)
Vue.use(MintUI)
// >>>引入图片预览插件
import photoPreview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(photoPreview, {
  loop: false, fullscreenEl: false, //是否全屏
  arrowEl: false, //左右按钮
})
// >>>引入地址路由
import router from './router'
import store from './vuex'
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js